//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectNXObject.js";
import "../Features/Features.ShipDesign.ShipNamesListBuilder.js";
import "../no/ErrorList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"AlgorithmVersion",1,0],[0,"AngularTolerance",1,0],[1,"ComponentsToCopy",0,"SelectNXObjectList",0],[0,"CopyApproachOption",1,0],[0,"CopySection",1,0],[0,"LinearTolerance",1,0],[1,"SelectionFrom",0,"SelectNXObject",0],[1,"SelectionTo",0,"SelectNXObjectList",0],[1,"ShipNames",0,"Features.ShipDesign.ShipNamesListBuilder",0],[0,"ShowXmlReport",1,0]],[[["nObjects","logicalObjects"],"CreateLogicalObjects",{},0,0],[[],"GetOperationFailures",{R_:{error_list:"ErrorList"}},0,0],[["objects"],"AutoAssignAttributes",{R_:{failedObjectsErrorInfo:"ErrorList"}},1,0],[["objects","properties"],"AutoAssignAttributesWithNamingPattern",{R_:{failedObjectsErrorInfo:"ErrorList"}},2,0],[["attributeTitles","titlePatterns"],"CreateAttributeTitleToNamingPatternMap",{R_:{attributeTitleToNamingPatternMap:"NXObject"}},2,0],[["object","nRevsOpt","revOptions"],"GetItemRevisionNamingRules",{},1,0],[["object","nPatterns","patternList"],"GetItemNamingRulePatterns",{},1,0]],[]];
SPLM.Features.ShipDesign.CopyPasteNewBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.CopyPasteNewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.CopyPasteNewBuilder.VersionID = Object.freeze({
    "Nx11" : "Nx11", "Nx12" : "Nx12"});

SPLM.Features.ShipDesign.CopyPasteNewBuilder.CopyApproach = Object.freeze({
    "TransferringLinkedBody" : "TransferringLinkedBody", "CopySourceFeaturesAndReparent" : "CopySourceFeaturesAndReparent"});

export default SPLM;